export const ROLES = {
  odontologo: { label: "Odontólogo/a", empresaLabel: "Consultorio o clínica" },
  laboratorio: { label: "Laboratorio dental", empresaLabel: "Nombre del laboratorio" },
};

// Estados de la orden, en orden. Los cambia el receptor (el laboratorio): uno adelante o uno atrás.
// "Para aprobar" es opcional y no se pone con un botón de estado: llega al enviar el diseño (recuadro Diseño)
// y sale con la decisión de la clínica. Los mismos pasos están en functions/estados.js y en firestore.rules.
export const ESTADO_FLOW = ["recibido", "en_diseno", "para_aprobar", "en_fabricacion", "enviado", "entregado"];

export const ESTADOS = {
  recibido: { label: "Recibido", tone: "amber" },
  en_diseno: { label: "En diseño", tone: "sky" },
  para_aprobar: { label: "Para aprobar", tone: "violet" },
  en_fabricacion: { label: "En fabricación", tone: "sky" },
  enviado: { label: "Enviado", tone: "brand" },
  entregado: { label: "Entregado", tone: "emerald" },
};

export const ESTADO_PASOS = {
  recibido: { avanzar: ["en_diseno"], volver: [] },
  en_diseno: { avanzar: ["en_fabricacion"], volver: ["recibido"] },
  para_aprobar: { avanzar: [], volver: ["en_diseno"] },
  en_fabricacion: { avanzar: ["enviado"], volver: ["en_diseno"] },
  enviado: { avanzar: ["entregado"], volver: ["en_fabricacion"] },
  entregado: { avanzar: [], volver: ["enviado"] },
};

// Estados desde los que el laboratorio puede enviar el diseño para aprobar (igual que functions/estados.js).
export const ENVIAR_DISENO_DESDE = ["recibido", "en_diseno", "para_aprobar"];

// Botones del receptor: un botón por cada paso adelante y uno para volver. En "En diseño" además aparece
// "Pasar a Para aprobar" (disenar), que no cambia el estado: lleva al recuadro Diseño. En "Para aprobar",
// "Avanzar sin aprobación" (sinAprobacion), que lo hace el servidor (no es un paso de la app).
export function statusActions(estado) {
  const pasos = ESTADO_PASOS[estado] || { avanzar: [], volver: [] };
  return { avanzar: pasos.avanzar, volver: pasos.volver[0] || null, disenar: estado === "en_diseno", sinAprobacion: estado === "para_aprobar" };
}

export const PRIORIDADES = ["Normal", "Urgente"];

export const GENEROS = ["Femenino", "Masculino", "Otro"];

// Odontograma en notación FDI, tal como se ve de frente al paciente.
export const CUADRANTES = [
  { id: 1, label: "Superior derecho", piezas: [18, 17, 16, 15, 14, 13, 12, 11] },
  { id: 2, label: "Superior izquierdo", piezas: [21, 22, 23, 24, 25, 26, 27, 28] },
  { id: 4, label: "Inferior derecho", piezas: [48, 47, 46, 45, 44, 43, 42, 41] },
  { id: 3, label: "Inferior izquierdo", piezas: [31, 32, 33, 34, 35, 36, 37, 38] },
];

export const PIEZAS_SUPERIORES = [...CUADRANTES[0].piezas, ...CUADRANTES[1].piezas];
export const PIEZAS_INFERIORES = [...CUADRANTES[2].piezas, ...CUADRANTES[3].piezas];
export const ORDEN_PIEZAS = [...PIEZAS_SUPERIORES, ...PIEZAS_INFERIORES];

export const TIPOS_TRABAJO = [
  "Corona monolítica",
  "Corona estratificada",
  "Cofia",
  "Incrustación",
  "Carilla",
  "Póntico",
  "Provisorio",
  "Férula",
  "Guía quirúrgica",
  "Modelo",
  "Otro",
];

export const MATERIALES = ["Zirconio", "Disilicato de litio", "Metal", "Metal-cerámica", "Resina", "PMMA", "Otro"];

export const COLORES = [
  "A1", "A2", "A3", "A3.5", "A4",
  "B1", "B2", "B3", "B4",
  "C1", "C2", "C3", "C4",
  "D2", "D3", "D4",
  "Otro",
];

// Contacto para quienes quieran publicitar en la app.
export const CONTACTO_PUBLICIDAD = {
  telefono: "+54 221 600-3908",
  whatsapp: "5492216003908",
};

// Publicidades contratadas: rutas a imágenes en public/assets.
// Mientras estén vacías se muestra el espacio "Publicitá acá" (AdSpace).
// Dashboard: imágenes horizontales 16:9. Nueva orden: imágenes verticales 1:2.
export const BANNERS_DASHBOARD = [];

export const BANNERS_ORDEN = [];
